<template>
    <div class="container mb-3" data-aos="fade-up">
        Contact
    </div>
  </template>
  
  <script>    
  </script>
  
  <style scoped>
  </style>
  